import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import useWindowSize from "../../utils/useWindowSize";
import PrivateNewMain2Desktop from "./PrivateNewMainDesktop";
import PrivateNewMain2Mobile from "./PrivateNewMainMobile";
import * as appActions from "../../redux/actions/appActions";
import * as cartActions from "../../redux/actions/cartActions";
import * as scuolaActions from "../../redux/actions/scuolaActions";
import * as scuolaNewActions from "../../redux/actions/scuolaNewActions";
import * as privateNewApi from "../../api/privateNewApi";
import moment from "moment";
import { updateTimeRangeWithSlot } from "../../utils/timeRangeUtils";
import RedirectWithTrack from "../common/RedirectWithTrack";
import { useTranslation } from "react-i18next";
import {
  isSchoolPromoActive,
  calculateDiscountedPrice,
  applyDiscountRounding,
} from "../../utils/skiworkUtils";

const PrivateNewMain = (props) => {
  const { width } = useWindowSize();
  const isMobile = width < 768; // You can adjust this breakpoint

  const { codScuola, lang } = props;

  const {
    appData,
    datiScuola,
    datiScuolaOld,
    cartData,
    clearAppData,
    loadSchoolDataNew,
    loadSchoolData,
    setSlug,
    setLang,
  } = props;

  const { i18n } = useTranslation([datiScuola.customTranslationNamespace]);

  ////////////////
  // State management
  // const [selectedArea, setSelectedArea] = useState(() => {
  //   if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  //     return "508eec57-a8e4-4d19-7165-08ddcec0aaa9";
  //   } else {
  //     return null;
  //   }
  // });
  // const [selectedSpecialita, setSelectedSpecialita] = useState(() => {
  //   if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  //     return "5b343cc5-829b-4bbe-5c60-08ddcec0aab1";
  //   } else {
  //     return null;
  //   }
  // });
  // const [selectedLivello, setSelectedLivello] = useState(() => {
  //   if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  //     return "424dbaa2-4d31-4733-e5bc-08ddcec0aaaa";
  //   } else {
  //     return null;
  //   }
  // });
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedSpecialita, setSelectedSpecialita] = useState(null);
  const [selectedLivello, setSelectedLivello] = useState(null);

  const [selectedLingua, setSelectedLingua] = useState("IT");
  const [selectedNumAllevi, setSelectedNumAllevi] = useState(1);
  const [isPreferenzeValid, setIsPreferenzeValid] = useState(false);
  const [hasBeenInitialized, setHasBeenInitialized] = useState(false);
  const [dateNonDisponibili, setDateNonDisponibili] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [idMaestro, setIdMaestro] = useState(-1);
  const [nomeMaestro, setNomeMaestro] = useState(null);
  const [maestroData, setMaestroData] = useState(null);
  const [disponibilità, setDisponibilità] = useState([]);
  const [primoGiorno, setPrimoGiorno] = useState(null);
  const [firstDayTimeSlots, setFirstDayTimeSlots] = useState([]);
  const [timeRangeFirstDay, setTimeRangeFirstDay] = useState(null);
  const [timeRangesOtherDays, setTimeRangesOtherDays] = useState({});
  const [prezziLezioni, setPrezziLezioni] = useState(null);
  const [isMaestroMode, setIsMaestroMode] = useState(false);
  const [showMaestriModal, setShowMaestriModal] = useState(false);
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
  const [redirectToCart, setRedirectToCart] = useState(false);
  const [allievi, setAllievi] = useState([]);
  const [showPupilModal, setShowPupilModal] = useState(false);
  const [isLoadingUnavailableDays, setIsLoadingUnavailableDays] =
    useState(false);

  ////////////////
  // Refs
  const prevSelectedDatesRef = useRef();

  ////////////////
  // Helper functions
  const validatePreferences = () => {
    return (
      selectedArea &&
      selectedSpecialita &&
      selectedLivello &&
      selectedLingua &&
      selectedNumAllevi
    );
  };

  const handleRecalculate = () => {
    console.log("handleRecalculate called");
    if (validatePreferences()) {
      console.log("Preferences are valid, setting isPreferenzeValid to true");
      setIsPreferenzeValid(true);
    } else {
      console.log("Preferences are NOT valid");
    }
  };

  const handleOpenMaestriModal = () => {
    setShowMaestriModal(true);
  };

  const handleCloseMaestriModal = () => {
    setShowMaestriModal(false);
  };

  const handleSelectMaestro = (maestroIdSkiwork, nomeMaestro, maestroData) => {
    console.log(
      "handleSelectMaestro called with:",
      maestroIdSkiwork,
      nomeMaestro,
    );

    setNomeMaestro(nomeMaestro);
    setMaestroData(maestroData);
    setShowMaestriModal(false);

    // Force recalculation with the new maestro
    setIsPreferenzeValid(false);
    setSelectedDates([]);
    setDateNonDisponibili([]);
    setDisponibilità([]);
    setPrezziLezioni(null);
    setTimeRangeFirstDay(null);
    setTimeRangesOtherDays({});

    // Set these AFTER resetting, to avoid race conditions
    setIdMaestro(maestroIdSkiwork);
    setIsMaestroMode(true);
  };

  // Handler for first day timeline that properly accesses current state
  const handleFirstDaySlotClick = (slot) => {
    setTimeRangeFirstDay((prevRange) => {
      // If the slot has the special marker indicating it's a full range
      // (from Timeline component's first click or click-within logic),
      // use it directly instead of going through updateTimeRangeWithSlot
      if (slot._isFullRange) {
        console.log("Setting range directly from slot:", slot);
        return { start: slot.start, end: slot.end };
      }
      return updateTimeRangeWithSlot(prevRange, slot);
    });
  };

  const handleMainCalendarDateChange = (date) => {
    if (date) {
      setSelectedDates((prevDates) => {
        // Check if date already exists in the array
        const dateExists = prevDates.some((existingDate) =>
          moment(existingDate).isSame(date, "day"),
        );

        let newDates;
        if (dateExists) {
          // Remove the date if it already exists
          newDates = prevDates.filter(
            (existingDate) => !moment(existingDate).isSame(date, "day"),
          );
        } else {
          // Add the new date
          newDates = [...prevDates, moment(date)];
        }

        // Sort the array by date
        const sortedDates = newDates.sort((a, b) => moment(a).diff(moment(b)));

        // Check if we have a new lowest date
        const currentLowestDate =
          prevDates.length > 0
            ? prevDates.sort((a, b) => moment(a).diff(moment(b)))[0]
            : null;
        const newLowestDate = sortedDates.length > 0 ? sortedDates[0] : null;

        if (
          newLowestDate &&
          (!currentLowestDate ||
            !moment(newLowestDate).isSame(currentLowestDate, "day"))
        ) {
          setPrimoGiorno(newLowestDate);
          setTimeRangeFirstDay(null); // Clear time range when changing the first day
          // We have a new lowest date, fetch availability for it
          fetchAvailabilityForDay(newLowestDate);
        }

        return sortedDates;
      });
    }
  };

  const fetchAvailabilityForDay = async (date) => {
    try {
      // Format date to YYYY-MM-DD for API
      const formattedDate = moment(date).format("YYYY-MM-DD");

      // Call the API with parameters from Step 1
      const response = await privateNewApi.getDisponibilitàGiorno(
        formattedDate,
        selectedArea,
        selectedSpecialita,
        selectedLivello,
        selectedLingua,
        idMaestro,
        cartData?.righePrivateNew ?? [],
      );

      // Transform API response to timeSlots format
      if (response && Array.isArray(response)) {
        console.log(response);
        setFirstDayTimeSlots(
          response.map((slot) => ({
            start: slot.dalle.slice(0, 5), // Convert "HH:mm:ss" to "HH:mm"
            end: slot.alle.slice(0, 5), // Convert "HH:mm:ss" to "HH:mm"
          })),
        );
      }
    } catch (error) {
      console.error("Error fetching availability:", error);
    }
  };

  const fetchBestAvailability = async (maestroId = idMaestro) => {
    // Validate the time range against fascia rules before proceeding
    if (timeRangeFirstDay && datiScuola.fasceSelezioneOre) {
      const {
        findApplicableFascia,
        isValidDuration,
        parseTimeToHours,
      } = require("../../utils/fasceSelezioneOreUtils");

      const fascia = findApplicableFascia(
        datiScuola.fasceSelezioneOre,
        primoGiorno,
        timeRangeFirstDay.start,
        timeRangeFirstDay.end,
      );

      if (fascia) {
        const startHours = parseTimeToHours(timeRangeFirstDay.start);
        const endHours = parseTimeToHours(timeRangeFirstDay.end);
        const duration = endHours - startHours;

        console.log("Validating duration against fascia rules:", {
          fascia,
          startHours,
          endHours,
          duration,
        });

        if (!isValidDuration(duration, fascia.soloOreIntere, fascia.tipoOrarioIntero, datiScuola.minOreAcquistabili)) {
          if (fascia.tipoOrarioIntero === 3) {
            alert(
              `La durata selezionata deve essere un multiplo di ${datiScuola.minOreAcquistabili} ore (es. ${datiScuola.minOreAcquistabili}, ${datiScuola.minOreAcquistabili * 2}, etc.)`
            );
          } else {
            alert(
              "La durata selezionata deve essere un numero intero di ore (es. 1, 2, 3 ore, non 1.5, 2.5, ecc.)",
            );
          }
          return;
        }
      }
    }

    const datesWithoutFirst = selectedDates
      .filter((date) => !moment(date).isSame(primoGiorno, "day"))
      .map((date) => moment(date).format("YYYY-MM-DD"));
    const response = await privateNewApi.getDisponibilitaMigliore(
      moment(primoGiorno).format("YYYY-MM-DD"),
      timeRangeFirstDay.start,
      timeRangeFirstDay.end,
      selectedArea,
      selectedSpecialita,
      selectedLivello,
      datesWithoutFirst,
      idMaestro,
      selectedLingua,
      cartData?.righePrivateNew ?? [],
    );

    console.log("Best availability response:", response);

    // Check if disponibilità is null, undefined, or empty
    if (!response.disponibilità || response.disponibilità.length === 0) {
      alert(i18n.t("nessuna_disponibilita_migliore"));
      return;
    }

    setDisponibilità(response.disponibilità);
    setIdMaestro(response.maestroIdSkiwork);
    setNomeMaestro(response.nome);
  };

  // Helper function to create time slots from disponibilità entry
  const createTimeSlotsFromDisponibilita = (dalle, alle) => {
    return [
      {
        start: dalle.slice(0, 5), // Convert "HH:mm:ss" to "HH:mm"
        end: alle.slice(0, 5), // Convert "HH:mm:ss" to "HH:mm"
      },
    ];
  };

  // Helper function to handle time slot click for a specific day
  const createOtherDaySlotClickHandler = (data) => {
    return (slot) => {
      setTimeRangesOtherDays((prev) => {
        // Always use the slot data directly as Timeline component
        // handles all business logic internally
        console.log(`Setting range for ${data}:`, slot);
        return {
          ...prev,
          [data]: { start: slot.start, end: slot.end },
        };
      });
    };
  };

  // Function to clear time range for a specific day
  const clearOtherDayTimeRange = (data) => {
    setTimeRangesOtherDays((prev) => ({
      ...prev,
      [data]: { start: undefined, end: undefined },
    }));
  };

  // Function to handle lesson confirmation
  const handleConfirmLessons = () => {
    // Open the pupil data modal before proceeding
    setShowPupilModal(true);
  };

  const handlePupilDataConfirm = (pupilsData) => {
    console.log("Confirming lessons with pupils data:", pupilsData);
    console.log("Lessons:", prezziLezioni);
    console.log("Time ranges:", timeRangesOtherDays);

    // Store the pupils data
    setAllievi(pupilsData);

    // Close the modal
    setShowPupilModal(false);

    props.addPrivataNew({
      idMaestro,
      maestroSelezionato: isMaestroMode,
      prezziLezioni,
      timeRangesOtherDays,
      selectedDates,
      selectedNumAllevi,
      specialitaId:
        props.datiScuola?.specialità?.[selectedSpecialita]?.idSkiwork,
      specialitaDesc:
        props.datiScuola?.specialità?.[selectedSpecialita]?.text || "",
      livelloId:
        props.datiScuola?.livelli?.[selectedLivello]?.idSkiwork ||
        selectedLivello,
      livelloDesc: props.datiScuola?.livelli?.[selectedLivello]?.text || "",
      lingua: selectedLingua,
      areaId:
        props.datiScuola?.areeOperative?.[selectedArea]?.idSkiwork ||
        selectedArea,
      areaDesc: props.datiScuola?.areeOperative?.[selectedArea]?.text || "",
      allievi: pupilsData,
      maestroDesc: nomeMaestro,
      scontoPromozione: (() => {
        const earlyPrivate = datiScuola?.earlyPaymentDiscountSettings?.private || datiScuola?.earlyPaymentDiscountSettings?.Private;
        if (earlyPrivate && earlyPrivate.percentage > 0) {
          return isSchoolPromoActive(true, earlyPrivate.percentage, earlyPrivate.deadline) ? earlyPrivate.percentage : 0;
        }
        const legacyPromo = datiScuola.promozionePriv ?? datiScuolaOld?.promozionePriv;
        const legacySconto = datiScuola.scontoPromozionePriv ?? datiScuolaOld?.scontoPromozionePriv;
        const legacyScadenza = datiScuola.scadenzaPromozionePriv ?? datiScuolaOld?.scadenzaPromozionePriv;
        return isSchoolPromoActive(legacyPromo, legacySconto, legacyScadenza) ? legacySconto : 0;
      })(),
      scontoAgenzia: appData?.agenzia?.sconto2 ?? 0,
    });

    //navigate to cart view
    setRedirectToCart(true);
  };

  const handlePupilDataCancel = () => {
    setShowPupilModal(false);
  };

  const addToCart = (item) => {
    props.addPrivataNew(item);
  };

  ////////////////
  // Side effects
  useEffect(() => {
    i18n.emit("languageChanged");
  }, [datiScuola.customTranslationNamespace, i18n]);

  useEffect(() => {
    if (appData.hasOwnProperty("lang")) {
      i18n.changeLanguage(appData.lang.toLowerCase());
    }
  }, [appData.lang, i18n, appData]);

  useEffect(() => {
    const needsRefetch =
      codScuola !== appData.slug ||
      lang !== appData.lang ||
      Object.keys(datiScuola).length === 0;

    if (needsRefetch) {
      if (codScuola !== appData.slug || lang !== appData.lang) {
        clearAppData();
      }
      // Use appData.lang if available, otherwise fall back to URL lang param
      const currentLang = appData.lang || lang;
      loadSchoolDataNew(codScuola, currentLang);
      loadSchoolData(codScuola, currentLang);
      setSlug(codScuola);
      setLang(currentLang);
    }
  }, [
    codScuola,
    lang,
    appData.slug,
    appData.lang,
    datiScuola,
    clearAppData,
    loadSchoolDataNew,
    loadSchoolData,
    setSlug,
    setLang,
  ]);

  // Debug: Track idMaestro changes
  useEffect(() => {
    console.log(
      "🔍 idMaestro changed to:",
      idMaestro,
      "isMaestroMode:",
      isMaestroMode,
    );
  }, [idMaestro, isMaestroMode]);

  // Initialize validation on first run when all preferences have values
  useEffect(() => {
    console.log("Init useEffect triggered", {
      hasBeenInitialized,
      selectedArea,
      selectedSpecialita,
      selectedLivello,
      selectedLingua,
      selectedNumAllevi,
      validateResult: validatePreferences(),
    });

    if (!hasBeenInitialized && validatePreferences()) {
      console.log(
        "✅ Initializing preferences as valid - Calendar should appear!",
      );
      setIsPreferenzeValid(true);
      setHasBeenInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedArea,
    selectedSpecialita,
    selectedLivello,
    selectedLingua,
    selectedNumAllevi,
    hasBeenInitialized,
  ]);

  // Invalidate when any preference changes (after initial validation)
  useEffect(() => {
    if (hasBeenInitialized && isPreferenzeValid) {
      console.log("Invalidating preferences due to change");
      setIsPreferenzeValid(false);
      setSelectedDates([]);
      setDateNonDisponibili([]);
      setDisponibilità([]);
      // Only reset idMaestro if we're NOT in maestro mode
      if (!isMaestroMode) {
        setIdMaestro(-1);
      }
      setPrezziLezioni(null);
      setTimeRangeFirstDay(null);
      setTimeRangesOtherDays({});
    }
    // We intentionally don't include isPreferenzeValid and hasBeenInitialized in dependencies
    // to avoid infinite loop and triggering on initialization
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedArea,
    selectedSpecialita,
    selectedLivello,
    selectedLingua,
    selectedNumAllevi,
  ]);

  useEffect(() => {
    if (isPreferenzeValid) {
      console.log("Preferences are valid, fetching unavailable days...");
      console.log("Current selectedDates:", selectedDates);
      console.log("Current dateNonDisponibili:", dateNonDisponibili);
      console.log("Current idMaestro:", idMaestro);

      setIsLoadingUnavailableDays(true);

      privateNewApi
        .getGiorniCompletamenteNonDisponibili(
          selectedArea,
          selectedSpecialita,
          selectedLivello,
          selectedLingua,
          idMaestro,
          cartData?.righePrivateNew ?? [],
        )
        .then((response) => {
          console.log("Fetched unavailable days:", response);
          if (response && Array.isArray(response)) {
            setDateNonDisponibili(response);
          }
        })
        .catch((error) => {
          console.error("Error fetching unavailable days:", error);
        })
        .finally(() => {
          setIsLoadingUnavailableDays(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isPreferenzeValid,
    selectedArea,
    selectedSpecialita,
    selectedLivello,
    selectedLingua,
    idMaestro,
  ]);

  useEffect(() => {
    setDisponibilità([]);
    // Only reset idMaestro if we're NOT in maestro mode
    if (!isMaestroMode) {
      setIdMaestro(-1);
    }
    setPrezziLezioni(null);

    // Compute previous lowest date
    const prevLowest =
      prevSelectedDatesRef.current && prevSelectedDatesRef.current.length > 0
        ? prevSelectedDatesRef.current.sort((a, b) =>
            moment(a).diff(moment(b)),
          )[0]
        : null;

    // Compute current lowest date
    const currentLowest =
      selectedDates.length > 0
        ? selectedDates.sort((a, b) => moment(a).diff(moment(b)))[0]
        : null;

    if (
      currentLowest &&
      (!prevLowest || !moment(currentLowest).isSame(prevLowest, "day"))
    ) {
      setTimeRangeFirstDay(null);
    }

    prevSelectedDatesRef.current = selectedDates;
  }, [selectedDates, isMaestroMode]);

  // Auto-create initial time selection when disponibilità loads
  useEffect(() => {
    if (
      disponibilità?.length > 0 &&
      !timeRangeFirstDay &&
      primoGiorno &&
      datiScuola.minOreAcquistabili
    ) {
      // Find the first disponibilità entry for primoGiorno
      const firstDayDisp = disponibilità.find((d) =>
        moment(d.data).isSame(primoGiorno, "day"),
      );

      if (firstDayDisp) {
        const {
          findApplicableFascia,
          parseTimeToHours,
        } = require("../../utils/fasceSelezioneOreUtils");

        const startTime = firstDayDisp.dalle; // e.g., "09:00:00"

        // Get fascia rules
        const fascia = findApplicableFascia(
          datiScuola.fasceSelezioneOre,
          primoGiorno,
          startTime.slice(0, 5),
        );

        // Calculate initial end time
        const startHours = parseTimeToHours(startTime);
        let initialDuration = datiScuola.minOreAcquistabili;

        // If soloOreIntere, round up to whole hour
        if (fascia && fascia.soloOreIntere) {
          initialDuration = Math.ceil(initialDuration);
        }

        const endHours = startHours + initialDuration;
        const endHour = Math.floor(endHours);
        const endMinute = (endHours % 1) * 60;
        const calculatedEndTime = `${endHour
          .toString()
          .padStart(2, "0")}:${endMinute.toString().padStart(2, "0")}`;

        console.log("Auto-creating initial selection:", {
          start: startTime.slice(0, 5),
          end: calculatedEndTime,
          fascia,
          minOreAcquistabili: datiScuola.minOreAcquistabili,
        });

        setTimeRangeFirstDay({
          start: startTime.slice(0, 5), // Remove seconds
          end: calculatedEndTime,
        });
      }
    }
  }, [
    disponibilità,
    timeRangeFirstDay,
    primoGiorno,
    datiScuola.minOreAcquistabili,
    datiScuola.fasceSelezioneOre,
  ]);

  // Prepopulate first day's time range when disponibilità is loaded
  useEffect(() => {
    if (disponibilità?.length > 0 && timeRangeFirstDay) {
      // Helper function to check if a time range fits completely within a slot
      const timeRangeFitsInSlot = (
        rangeStart,
        rangeEnd,
        slotStart,
        slotEnd,
      ) => {
        // Convert time strings to comparable format (remove seconds if present)
        const normalizeTime = (time) => time.slice(0, 5); // Get HH:mm

        const normalizedRangeStart = normalizeTime(rangeStart);
        const normalizedRangeEnd = normalizeTime(rangeEnd);
        const normalizedSlotStart = normalizeTime(slotStart);
        const normalizedSlotEnd = normalizeTime(slotEnd);

        const fits =
          normalizedRangeStart >= normalizedSlotStart &&
          normalizedRangeEnd <= normalizedSlotEnd;

        return fits;
      };

      // Prepopulate time ranges for all days where the first day's range fits
      setTimeRangesOtherDays((prev) => {
        const newRanges = {};

        // First, group disponibilità by date to handle multiple entries per day
        const groupedByDate = disponibilità.reduce((acc, disp) => {
          const { data, dalle, alle } = disp;
          if (!acc[data]) {
            acc[data] = [];
          }
          acc[data].push({ dalle, alle });
          return acc;
        }, {});

        // Process each date
        Object.entries(groupedByDate).forEach(([data, timeSlots]) => {
          // Check if this day already has confirmed ranges
          if (prev[data] && prev[data].start && prev[data].end) {
            // Keep existing ranges
            console.log(
              `Day ${data} already has ranges, keeping them:`,
              prev[data],
            );

            newRanges[data] = prev[data];
          } else {
            // Check if the first day's time range fits in ANY of this day's slots
            const fitsInAnySlot = timeSlots.some((slot) =>
              timeRangeFitsInSlot(
                timeRangeFirstDay.start,
                timeRangeFirstDay.end,
                slot.dalle,
                slot.alle,
              ),
            );

            if (fitsInAnySlot) {
              // Prepopulate with first day's time range
              console.log(
                `Prepopulating day ${data} with range:`,
                timeRangeFirstDay,
              );
              newRanges[data] = {
                start: timeRangeFirstDay.start,
                end: timeRangeFirstDay.end,
              };
            } else {
              // If it doesn't fit, leave it empty
              newRanges[data] = { start: undefined, end: undefined };
              console.log(
                `Day ${data} range doesn't fit in any slot, leaving empty`,
              );
            }
          }
        });

        return newRanges;
      });
    }
  }, [disponibilità, timeRangeFirstDay]);

  useEffect(() => {
    if (Object.keys(timeRangesOtherDays).length !== 0) {
      console.log("timeRangesOtherDays changed:", timeRangesOtherDays);

      // Make async API call to calculate price
      const calculatePrice = async () => {
        try {
          const agencyId = appData?.agenzia?.idAgenzia || null;
          const result = await privateNewApi.calcolaPrezzoLezioniPrivate(
            timeRangesOtherDays,
            selectedNumAllevi,
            selectedSpecialita,
            agencyId,
          );
          console.log("Price calculation result:", result);

          const earlyPrivate = datiScuola?.earlyPaymentDiscountSettings?.private || datiScuola?.earlyPaymentDiscountSettings?.Private;
          const hasAgency = Boolean(appData?.agenzia);
          const skipPromo = hasAgency && !appData.agenzia.applicaPromozioni;
          const agencyPerc = hasAgency ? (appData?.agenzia?.sconto2 ?? 0) : 0;

          let promoActive = false;
          let promoPerc = 0;

          if (!skipPromo) {
            if (earlyPrivate && earlyPrivate.percentage > 0) {
              promoActive = isSchoolPromoActive(true, earlyPrivate.percentage, earlyPrivate.deadline);
              promoPerc = promoActive ? earlyPrivate.percentage : 0;
            } else {
              const legacyPromo = datiScuola.promozionePriv ?? datiScuolaOld?.promozionePriv;
              const legacySconto = datiScuola.scontoPromozionePriv ?? datiScuolaOld?.scontoPromozionePriv;
              const legacyScadenza = datiScuola.scadenzaPromozionePriv ?? datiScuolaOld?.scadenzaPromozionePriv;

              promoActive = isSchoolPromoActive(legacyPromo, legacySconto, legacyScadenza);
              promoPerc = promoActive ? legacySconto : 0;
            }
          }

          const roundingMode = datiScuola.discountRoundingMode ?? datiScuola.DiscountRoundingMode ?? datiScuola.arrotondamentoVIP ?? datiScuolaOld?.arrotondamentoVIP ?? 0;

          const discountedResult = {};
          for (const [key, pricesArray] of Object.entries(result)) {
            if (pricesArray && pricesArray.length >= 3) {
              const listPriceObj = pricesArray[0]; // Index 0 is PrezzoListino
              const currentPriceObj = pricesArray[1]; // Index 1 is Prezzo
              const currentDepositObj = pricesArray[2]; // Index 2 is PrezzoPag

              const listPrice = listPriceObj.amount;
              const currentPrice = currentPriceObj.amount;

              let agencyPrice = currentPrice;
              if (agencyPerc > 0) {
                const base = listPrice > 0 ? listPrice : currentPrice;
                agencyPrice = base * (1 - agencyPerc / 100);
              }
              let finalPrice = agencyPrice;
              if (promoActive && promoPerc > 0) {
                finalPrice = agencyPrice * (1 - promoPerc / 100);
              }
              const discountedPrice = applyDiscountRounding(finalPrice, roundingMode);

              let discountedDeposit = currentDepositObj.amount;
              if (currentPriceObj.amount === currentDepositObj.amount) {
                discountedDeposit = discountedPrice;
              }

              const effectiveListPrice = (promoActive && promoPerc > 0 && hasAgency)
                ? agencyPrice
                : listPrice;

              discountedResult[key] = [
                { ...listPriceObj, amount: effectiveListPrice },
                { ...currentPriceObj, amount: discountedPrice },
                { ...currentDepositObj, amount: discountedDeposit },
              ];
            } else {
              discountedResult[key] = pricesArray;
            }
          }

          setPrezziLezioni(discountedResult);
        } catch (error) {
          console.error("Error calculating price:", error);
        }
      };

      calculatePrice();
    }
  }, [timeRangesOtherDays, selectedNumAllevi, selectedSpecialita, appData]);

  // Validate if confirm button should be enabled
  useEffect(() => {
    if (!prezziLezioni) {
      setIsConfirmEnabled(false);
      return;
    }

    // Check if all lessons have valid amounts (not undefined and not 0)
    // prezziLezioni is an object where each value is an array [listPrice, actualPrice, deposit]
    const allAmountsValid = Object.values(prezziLezioni).every(
      (lessonPrices) => {
        // lessonPrices is an array of price objects
        if (!Array.isArray(lessonPrices) || lessonPrices.length < 3) {
          return false;
        }
        // Check the deposit (third element)
        const deposit = lessonPrices[2];
        return deposit?.amount !== undefined && deposit?.amount > 0;
      },
    );

    setIsConfirmEnabled(allAmountsValid);
  }, [prezziLezioni]);

  // Prepare shared props for both desktop and mobile
  const sharedProps = {
    // State
    selectedArea,
    setSelectedArea,
    selectedSpecialita,
    setSelectedSpecialita,
    selectedLivello,
    setSelectedLivello,
    selectedLingua,
    setSelectedLingua,
    selectedNumAllevi,
    setSelectedNumAllevi,
    isPreferenzeValid,
    hasBeenInitialized,
    dateNonDisponibili,
    selectedDates,
    idMaestro,
    setIdMaestro,
    nomeMaestro,
    maestroData,
    disponibilità,
    primoGiorno,
    firstDayTimeSlots,
    timeRangeFirstDay,
    setTimeRangeFirstDay,
    timeRangesOtherDays,
    prezziLezioni,
    isMaestroMode,
    setIsMaestroMode,
    showMaestriModal,
    setShowMaestriModal,
    isConfirmEnabled,
    allievi,
    setAllievi,
    showPupilModal,
    setShowPupilModal,
    isLoadingUnavailableDays,

    // Handlers
    handleRecalculate,
    handleOpenMaestriModal,
    handleCloseMaestriModal,
    handleSelectMaestro,
    handleFirstDaySlotClick,
    handleMainCalendarDateChange,
    fetchBestAvailability,
    createTimeSlotsFromDisponibilita,
    createOtherDaySlotClickHandler,
    clearOtherDayTimeRange,
    handleConfirmLessons,
    handlePupilDataConfirm,
    handlePupilDataCancel,
    addToCart,
  };

  if (redirectToCart) {
    return <RedirectWithTrack to={`/${lang}/${codScuola}/cart`} push />;
  }

  return isMobile ? (
    <PrivateNewMain2Mobile {...props} {...sharedProps} />
  ) : (
    <PrivateNewMain2Desktop {...props} {...sharedProps} />
  );
};

function mapStateToProps(state, ownProps) {
  return {
    codScuola: ownProps.match.params.slug,
    lang: ownProps.match.params.lang,
    datiScuola: state.scuolaNewReducer,
    datiScuolaOld: state.scuolaReducer,
    loading: state.apiCallsInProgress > 0,
    appData: state.appReducer,
    cartData: state.cartReducer,
  };
}

const mapDispatchToProps = {
  setLang: appActions.setLang,
  setSlug: appActions.setSlug,
  clearAppData: appActions.clearAppData,
  loadSchoolData: scuolaActions.loadSchoolData,
  loadSchoolDataNew: scuolaNewActions.loadSchoolDataNew,
  addPrivataNew: cartActions.addPrivataNew,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateNewMain);
